import React, { useEffect } from 'react';
import { Card, ErrorMessage } from '../../../ui-toolkit';
import { useAppDispatch } from '../../../store/store';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../types/shared/UUID';
import { getClientOrderDocumentsAction } from '../../../store/clientPortal/clientOrderDocumentsSlice';
import { RootStore } from '../../../store/types';
import { DocumentsTable } from '../../../components/clientPortal/orderOverview/DocumentsTable';
import { UploadDocumentController } from '../../../components/order/documentsPortal/standardDocuments/UploadDocumentController';
import { IUploadDocument } from '../../../types/order/documents/upload/interfaces';
import {
  getAdminDocuments,
  resetUploadDocumentStatus,
  uploadDocuments,
} from '../../../store/order/documents/adminDocuments/dispatch';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { Show } from '../../../components/shared/Show';
import {
  defaultNormalizedDocumentCategoriesData,
  useListDocumentCategoriesQuery,
} from '../../../API/documentCategories/DocumentCategoriesApi';

export const ClientDocumentsContainer: React.FC = () => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getClientOrderDocumentsAction(orderId));
  }, [dispatch, orderId]);

  const { data: { allCategories, documentCategoriesByName } = defaultNormalizedDocumentCategoriesData } =
    useListDocumentCategoriesQuery();

  const { documents, documentsError } = useSelector((state: RootStore) => state.order.documents.adminDocuments);

  useEffect(() => {
    dispatch(getAdminDocuments(orderId, allCategories));
  }, [orderId, dispatch, allCategories]);

  const { uploadDocumentsFetchStatus, uploadDocumentsError } = useSelector(
    (state: RootStore) => state.order.documents.adminDocuments
  );

  const pageError = documentsError || uploadDocumentsError;
  const onSubmit = async (documents: IUploadDocument[]) => {
    await dispatch(uploadDocuments(orderId, documents, [], true));
    await dispatch(getAdminDocuments(orderId, allCategories));
  };

  const onReset = () => {
    dispatch(resetUploadDocumentStatus(orderId));
  };

  return (
    <Show when={!isEmpty(documentCategoriesByName)}>
      <Card>
        <ErrorMessage message={pageError} />
        <UploadDocumentController
          documentCategoriesByName={documentCategoriesByName}
          onSubmit={onSubmit}
          onReset={onReset}
          uploadFetch={uploadDocumentsFetchStatus}
          dropdownMessage={'*Note: We do not support .FNM files for 1003s'}
        />
        <DocumentsTable
          documents={documents[orderId] || []}
          orderId={orderId}
          documentCategoriesByName={documentCategoriesByName}
        />
      </Card>
    </Show>
  );
};
